export default function (element, options = {}) {
    if (!element) {
        return;
    }
    element.classList.add('c-amount');
    const { addEuroSign = false, keepFlat = false } = options;
    if (keepFlat) {
        element.classList.add('c-amount--flat');
    }
    let amountText = element.innerHTML;
    if (amountText && amountText.indexOf('<span class="c-amount__cents">') === -1) {
        let hasNoEuroSign = amountText.indexOf('€') === -1;
        if (hasNoEuroSign && addEuroSign) {
            amountText = amountText.replace(/(\d*)/,'€&nbsp;$1');
        }
        element.innerHTML = amountText.replace(/(\d*),(\d*)/, `$1,<span class="c-amount__cents">$2</span>`);
    }
}
